import React from "react";

import "./UserInvitation.css";
import { Icon } from "../../Icon/Icon";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const UserInvitation = ({ accountId }) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div
      className="UserInvitation"
      onClick={() => {
        history.push("invite-user");
      }}
    >
      <div className="UserInvitation__icon">
        <Icon name="iconAdd" width={12} height={14} />
      </div>
      <div className="UserInvitation__text">{t("Invite user")}</div>
    </div>
  );
};
